import React, { useCallback, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { Box } from '@mui/material';

import BackButton from '@ts-core/components/BackButton';

import { useCourseActivityByMonth } from 'modules/billing/hooks/useCourseActivityByMonth';
import { CourseActivityByMonthTable } from '@ts-core/modules/billing/components/CourseActivityByMonthTable';
import { YearMonthSelector, YearMonthDate } from '@ts-core/modules/billing/components/YearMonthSelector';
import { ActivityType } from '@ts-core/modules/billing/types';

import useCourse from 'modules/courses/hooks/useCourse';
import useAcademy from 'modules/academies/hooks/useAcademy';
import { useNewBillingStartingDateComponents } from 'modules/billing/hooks/useNewBillingStartingDateComponents';

export default function CourseActivityByMonthPage() {
  const history = useHistory();
  const { courseId, month: urlMonth, year: urlYear } = useParams<{ courseId: string; year: string; month: string }>();
  const [date, setDate] = useState<YearMonthDate>({ year: urlYear, month: urlMonth });
  const { year, month } = date;
  const { year: minYear, month: minMonth } = useNewBillingStartingDateComponents();

  const { courseActivity, loading } = useCourseActivityByMonth({ courseId, month, year });
  const { course } = useCourse({ courseId });
  const { academy } = useAcademy();

  const handleGoBack = useCallback(() => {
    history.push(`/billing/${year}/${month}`);
  }, [history, year, month]);

  const getActivityRoute = useCallback(
    (type: ActivityType, studentId: string) => {
      return `/billing/${year}/${month}/${courseId}/${studentId}/${type}`;
    },
    [courseId, month, year]
  );

  return (
    <Box>
      <BackButton noMargin onGoBack={handleGoBack} title={course?.name} subtitle={academy?.name} />
      <YearMonthSelector sx={{ mt: 3, mb: 2 }} onChangeDate={setDate} minYear={minYear} minMonth={minMonth} date={date} />
      <CourseActivityByMonthTable courseActivity={courseActivity} loading={loading} getActivityRoute={getActivityRoute} />
    </Box>
  );
}
